var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',{staticClass:"tours"},_vm._l((_vm.initTours),function(tour){return _c('tour',{key:tour.id,attrs:{"tour":tour}})}))}
var staticRenderFns = []

export { render, staticRenderFns }